import App from './views/App.vue';
import router from './routes';

import AkApprovalStatusSelect from "./widgets/AkApprovalStatusSelect.vue";
import AkAddress from "./widgets/AkAddress.vue";

Vue.component('ak-approval-status-select', AkApprovalStatusSelect);
Vue.component('ak-address', AkAddress);

let app = new Vue({
        data() { 
            return {
                globalMessages: []
            }
        },
        router,
        render: h => h(App),
}).$mount('#app')

AppKit.init(app);
